import $ from 'jquery';
import 'bootstrap';
import edvPartnerNavigation from "./navigation";
import edvBlockCounter from "./block-counter";
import partnerSwiper from "./partner-swiper";
import onWindowLoad from "./load";
import onResizeWindow from "./resize";
import edvGridModule from "./edv-grid-module";
import edvJobs from "./edv-jobs";
import edvBlockCounterExt from "./block-counter-ext";
import reviewsSwiper from "./reviews-swiper";
import edvFlipbox from "./edv-flipbox";
import edvBlockFullWidth from "./block-full-width";
import servicesSwiper from "./edv-services-swiper";
import edvCustomizeUltimateMember from "./edv_customize_ultimate_member";
import manufacturer from "./manufacturer";
import edvTicketsystem from "./ticketsystem";

$(document).ready(() => {
    $(".hamburg").click(function(){
        $(this).toggleClass("checked");
        if($(this).hasClass("checked")) {
            $('body').addClass('mobile-nav-is-open');
        } else {
            $('body').removeClass('mobile-nav-is-open');
        }

    });
    $('a[href="#edv-partner"]').click(function(e){
        e.preventDefault();
        let position = $('#edv-partner').offset().top + 450;
        $('html, body').animate({
            scrollTop: position
        }, 200);
    });
    edvPartnerNavigation();
    edvBlockCounter('.main-counter-module');
    partnerSwiper();
    onWindowLoad();
    onResizeWindow();
    edvGridModule();
    edvJobs();
    edvBlockCounterExt();
    reviewsSwiper();
    edvFlipbox();
    edvBlockFullWidth();
    servicesSwiper();
    edvCustomizeUltimateMember();
    manufacturer();
    edvTicketsystem();

    $('.accordion-button').click(function() {
        let currentCollapseElement = $(this).closest('.accordion-item').find('.accordion-collapse');
        let currentSiblings = $(this).closest('.accordion-item').siblings('.accordion-item').length;

        if(currentSiblings > 0) {
            if (currentCollapseElement.is('.show')) {
                currentCollapseElement.slideUp(400, function() {
                    $(this).removeClass('show');
                });
            } else {
                $('.accordion-collapse.show').slideUp(400, function() {
                    $(this).removeClass('show');
                });

                currentCollapseElement.slideDown(400, function() {
                    $(this).addClass('show');
                });
            }
        }

    });

    document.addEventListener( 'wpcf7mailsent', function( event ) {
        window.dataLayer.push({
            "event" : "edv_contact_success",
        })
    });

});




